import { Action } from '@ngrx/store';

// actions.js
export const RESET_STORE = 'RESET_STORE';


export class ResetStore implements Action {
  readonly type = RESET_STORE;
}

export type ResetStoreActions = ResetStore;